import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminAdminsListPage = () => {
  return (
    <PageProvider>
      <Helmet>
        <title>Admin Management - AutoScript Admin</title>
      </Helmet>
      <Content />
    </PageProvider>
  );
};
